import useInstanceTagsActions from '@lib/composables/instanceTagsActions.use'
import { HIDE_TAGS_WITH_PREFIX } from '@lib/constants/conventions.const'
import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'
import type { InstanceTagsCanvasType, InstanceTagsType } from '@lib/types/instanceTags.types'
import { computed, inject } from 'vue'
import type { ComputedRef } from 'vue'

export default function useSuggestedTags() {
  const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
    'launchDarkly',
    computed(() => ({})),
  )
  const { fetchInstanceTags } = useInstanceTagsActions()

  async function fetchSuggestedInstanceTags(
    search: string,
    {
      includeHidden,
      canvasType,
      type,
    }: {
      includeHidden?: boolean
      canvasType?: InstanceTagsCanvasType
      type?: InstanceTagsType[]
    } = {},
  ) {
    if (!launchDarkly.value.enable_suggested_tags) {
      return []
    }
    const instanceTags = await fetchInstanceTags({
      search,
      page: 1,
      pageSize: 50,
      includeHidden,
      canvasType,
      type,
    })

    const normalizedTags = instanceTags.map((tag) => tag.name)
    const filteredTags = normalizedTags.filter(
      (t) => !HIDE_TAGS_WITH_PREFIX.some((prefix) => t.startsWith(prefix)) && !t.startsWith('!'),
    )

    return filteredTags
  }

  return {
    fetchSuggestedInstanceTags,
  }
}
